export default (function() {
  return function() {
  }
})();
